module.exports = __webpack_public_path__ + "img/notice.707d54d4.png";